import PropTypes from "prop-types";
import React from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import {
  clockIn,
  clockOut,
  getActiveClock,
  getTimeClockByPayPeriod
} from "actions/account";
import { getTimeLogByDaySummary } from "actions/qualityAssurance";
import { MSpinner } from "components/Shared";
import { TimeLogs } from "components/User";
import {
  getCaseTimeLogByUserPayPeriod,
  getPayPeriodList
} from "actions/casetimelog";
import { ClockInOutCard, ProductionTimeCard, SummaryCard } from "../../components/Shared/TimeLogs";
import { CaseTimeLogWorkTypeEnum } from "interfaces/Mueller.Business.Models.ts";
class QATimeLogs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPayPeriodIndex: 0
    };
  }
  UNSAFE_componentWillMount() {
    this.props.getPayPeriodList();
  }
  render() {
    if (this.props.isFetchingPayPeriods) {
      return <MSpinner />;
    }
    return (
      <Grid container spacing={2} className="qa-timelogs">
        <Grid item xs={6}>
          <TimeLogs
            isFetchingTimeLogs={this.props.isFetchingTimeLogs}
            timeLogs={this.props.timeLogs}
            payPeriods={this.props.payPeriods}
            isFetchingPayPeriods={this.props.isFetchingPayPeriods}
            getCaseTimeLogByUserPayPeriod={
              this.props.getCaseTimeLogByUserPayPeriod
            }
            getPayPeriodList={this.props.getPayPeriodList}
            displayJustSummaryCard={true}
            callBackPayPeriod={index =>
              this.setState({ selectedPayPeriodIndex: index })
            }
            selectedPayPeriodIndex={this.state.selectedPayPeriodIndex}
          />
        </Grid>
        <Grid item xs={6}>
          <ClockInOutCard
            activeClock={this.props.activeClock}
            displayClockInOutButton={true}
            data={this.props.timeClockByPayPeriod}
            isFetchingData={this.props.isFetchingTimeClockByPayPeriod}
            payPeriod={
              this.props.payPeriods[this.state.selectedPayPeriodIndex]
            }
            getData={this.props.getTimeClockByPayPeriod}
            getActiveClock={this.props.getActiveClock}
            isFetchingActiveClock={this.props.isFetchingActiveClock}
            clockIn={this.props.clockIn}
            clockOut={this.props.clockOut}
            updatingUser={this.props.updatingUser}
          />
        </Grid>
        <Grid item xs={6}>
          <ProductionTimeCard
            data={this.props.timeLogs}
            isFetchingData={this.props.isFetchingTimeLogs}
            filterDate={this.state.filterDate}
            payPeriod={
              this.props.payPeriods[this.state.selectedPayPeriodIndex]
            }
            getData={this.props.getCaseTimeLogByUserPayPeriod}
            internetUserId={0}
            workTypeId={CaseTimeLogWorkTypeEnum.FIELD_REVIEW}
          />
        </Grid>
        <Grid item xs={6}>
          <SummaryCard
            summary={this.props.timeLogByDaySummary}
            filterDateCallBack={date => this.setState({ filterDate: date })}
            isFetchingData={this.props.isFetchingTimeLogByDaySummary}
            getData={this.props.getTimeLogByDaySummary}
            payPeriodId={
              this.props.payPeriods[this.state.selectedPayPeriodIndex].id
            }
            data={this.props.timeLogByDaySummary}
            internetUserId={0}
            isBusOpsEmployeeTimeLogs={true}
          />
        </Grid>
      </Grid>
    );
  }
}

QATimeLogs.propTypes = {
  updatingUser: PropTypes.bool.isRequired,
  isFetchingActiveClock: PropTypes.bool.isRequired,
  activeClock: PropTypes.object,
  getActiveClock: PropTypes.func.isRequired,
  clockIn: PropTypes.func.isRequired,
  clockOut: PropTypes.func.isRequired,
  getCaseTimeLogByUserPayPeriod: PropTypes.func.isRequired,
  getPayPeriodList: PropTypes.func.isRequired,
  isFetchingTimeLogs: PropTypes.bool.isRequired,
  timeLogs: PropTypes.array.isRequired,
  isFetchingPayPeriods: PropTypes.bool.isRequired,
  payPeriods: PropTypes.array.isRequired,
  timeClockByPayPeriod: PropTypes.array.isRequired,
  isFetchingTimeClockByPayPeriod: PropTypes.bool.isRequired,
  getTimeClockByPayPeriod: PropTypes.func.isRequired,
  isFetchingTimeLogByDaySummary: PropTypes.bool.isRequired,
  timeLogByDaySummary: PropTypes.object.isRequired,
  getTimeLogByDaySummary: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    updatingUser: state.user.updatingUser,
    isFetchingActiveClock: state.user.isFetchingActiveClock,
    activeClock: state.user.activeClock,
    isFetchingTimeLogs: state.caseTimeLog.isFetchingTimeLogs,
    timeLogs: state.caseTimeLog.timeLogs,
    isFetchingPayPeriods: state.caseTimeLog.isFetchingPayPeriods,
    payPeriods: state.caseTimeLog.payPeriods,
    timeClockByPayPeriod: state.user.timeClockByPayPeriod,
    isFetchingTimeClockByPayPeriod: state.user.isFetchingTimeClockByPayPeriod,
    timeLogByDaySummary: state.qualityAssurance.timeLogByDaySummary,
    isFetchingTimeLogByDaySummary:
      state.qualityAssurance.isFetchingTimeLogByDaySummary
  };
};

const mapDispatchToProps = dispatch => ({
  getActiveClock(timeZoneOffset) {
    dispatch(getActiveClock(timeZoneOffset));
  },
  clockIn(timeZoneOffset) {
    dispatch(clockIn(timeZoneOffset));
  },
  clockOut(timeZoneOffset) {
    dispatch(clockOut(timeZoneOffset));
  },
  getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId) {
    dispatch(getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId));
  },
  getPayPeriodList() {
    dispatch(getPayPeriodList());
  },
  getTimeClockByPayPeriod(internetUserId, payPeriodId) {
    dispatch(getTimeClockByPayPeriod(internetUserId, payPeriodId));
  },
  getTimeLogByDaySummary(internetUserId, payPeriodId) {
    dispatch(getTimeLogByDaySummary(internetUserId, payPeriodId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QATimeLogs);
